import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import { TextBody } from '../text/index.js';
import { badge } from './badge.css.js';
import { isLabelUppercase } from '../../utils/display-utils.js';
export const Badge = ({ size = 'medium', weight = 'light', type = 'neutral', label, className, prefix, testId, }) => {
    return (_jsxs("div", { className: clsx([className, badge({ size, weight, type })]), "data-testid": testId, children: [prefix, _jsx(TextBody, { display: "block", size: "small", tag: "span", transform: typeof label === 'string' && isLabelUppercase(label)
                    ? 'uppercase'
                    : undefined, truncate: true, weight: size === 'small' ? 'semibold' : 'medium', children: label })] }));
};
